import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home';
import EcomProject from './EcomProject';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/index.css';
import './assets/css/collab.css';
import DividoProject from './DividoProject';
import PixelProject from './PixelProject';
import IgniteAIProject from './IgniteAIProject';
import ScrollToTop from './ScrollToTop';
function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ecom-project" element={<EcomProject />} />
          <Route path="/divido-project" element={<DividoProject />} />
          <Route path="/pixel-project" element={<PixelProject />} />
          <Route path="/igniteai-project" element={<IgniteAIProject />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
